import { render, staticRenderFns } from "./WorkplaceTransactions.vue?vue&type=template&id=8cb6413e"
import script from "./WorkplaceTransactions.vue?vue&type=script&lang=ts"
export * from "./WorkplaceTransactions.vue?vue&type=script&lang=ts"
import style0 from "./WorkplaceTransactions.vue?vue&type=style&index=0&id=8cb6413e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports